import { render, staticRenderFns } from "./GiftDialog.vue?vue&type=template&id=948bd67e&scoped=true"
import script from "./GiftDialog.vue?vue&type=script&lang=js"
export * from "./GiftDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=948bd67e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948bd67e",
  null
  
)

export default component.exports